import ScreenLock from "../__constants/lock-screen";

const $ = jQuery.noConflict();

class AjaxAddToCart {
    constructor() {
        this.button = '.single_add_to_cart_button';
    }

    init() {
        this.submitEvent();
    }

    submitEvent() {
        $(document).on('click', this.button, (event) => {
            event.preventDefault();
            const btn = event.currentTarget;
            const form = btn.closest('form.cart');
            const qty = $(form).find('input[name="quantity"]').val() || 1;
            const productID = $(form).find('input[name="product_id"]').val() || 0;
            const variationID = $(form).find('input[name=variation_id]').val() || 0;
            this.submitAjax(btn, productID, qty, variationID);
        });
    }

    submitAjax(btn, productID, qty, variationID) {
        const data = {
            action: 'woocommerce_ajax_add_to_cart',
            product_id: productID,
            product_sku: '',
            quantity: qty,
            variation_id: variationID,
        };

        $(document.body).trigger('adding_to_cart', [$(btn), data]);

        $.ajax({
            type: 'post',
            url: WP.ajaxUrl,
            data,
            beforeSend: () => {
                $(btn).removeClass('added').addClass('loading');
            },
            complete: () => {
                $(btn).addClass('added').removeClass('loading');
            },
            success: (response) => {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                } else {
                    $(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $(btn)]);


                    // Close popup
                    $('.product-popup-overlay').removeClass('active');
                    $('.product-popup.active').removeClass('active');
                    ScreenLock.unlock();

                    // Open Cart
                    $.ajax({
                        type: 'post',
                        url: WP.ajaxUrl,
                        data: {
                            action: 'woocommerce_ajax_get_cart',
                        },
                        success: (response) => {
                            $('html, body').animate({scrollTop: '0'}, 300);
                            setTimeout(() => {
                                $('.sticky-cart').html(response).addClass('active');
                                $('.sticky-cart-overlay').addClass('active');
                                ScreenLock.lock();
                            }, 300);
                        },
                    });
                }
            },
        });
    }
}

export default new AjaxAddToCart();
